// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"8efc9034","183":"f34e3297","330":"6f80b1cb","674":"f693d257"}[chunkId] + ".chunk.js";
};